import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import "../../Styling/AdminDashboard.css";
import DeleteIcon from "../../assets/delete.png";
import { Button, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Loader from "../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrder,
  getAllAdminOrders,
} from "../../Redux/Actions/orderActions";
import { baseUrl } from "../../UrlHelper/baseUrl";
import { toast } from "react-toastify";
import { clearErrors } from "../../Redux/Actions/productActions";
import { ADMIN_DELETE_ORDER_RESET } from "../../Redux/Constants/orderConstants";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AdminAllOrders = () => {
  const { orders, loading } = useSelector((state) => state.allOrders);
  console.log("Orders data:", orders);
  const { error, isDeleted } = useSelector((state) => state.updateOrder);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ✅ Modal states
  const [openModal, setOpenModal] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);

  // ✅ Delete handler
  const deleteOrderHandler = async (orderId) => {
    if (!orderId) {
      toast.error("Order ID not found");
      return;
    }
    toast.success("Deleting order...");
    dispatch(deleteOrder(orderId));
    // We don't need to call getAllAdminOrders here as it will be triggered by the useEffect when isDeleted changes
  };

  // ✅ Check Order Status handler
  const checkOrderStatus = async (merchantOrderId, order) => {
    try {
      const tokenRes = await axios.get(`${baseUrl}/get-token`);
      const accessToken = tokenRes.data.access_token;

      const { data } = await axios.post(`${baseUrl}/checkOrderStatus`, {
        accessToken,
        merchantOrderId,
      });

      setOrderDetails({
        merchantOrderId,
        status: data.state,
        amount: data.amount,
        transactionId: data.paymentDetails?.[0]?.transactionId || "N/A",
        paymentMode: data.paymentDetails?.[0]?.paymentMode || "N/A",
        totalPrice: order?.totalPrice || "N/A",
        country: order?.country || "N/A",
        address: order?.address || "N/A",
        raw: JSON.stringify(data, null, 2),
      });

      setOpenModal(true);
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to check order status");
    }
  };

  // ✅ Columns for DataGrid
  const columns = [
    { field: "name", headerName: "Name", minWidth: 150, flex: 0.6 },
    { field: "age", headerName: "Age", minWidth: 100, flex: 0.3 },
    { field: "city", headerName: "City", minWidth: 120, flex: 0.5 },
    { field: "address", headerName: "Address", minWidth: 200, flex: 1 },
    {
      field: "phone",
      headerName: "Phone No.",
      minWidth: 150,
      flex: 0.5,
      renderCell: (params) => (
        <a
          href={`https://wa.me/${params.value}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#ffffffff", textDecoration: "none" }}
        >
          {params.value}
        </a>
      ),
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      minWidth: 150,
      flex: 0.5,
      type: "number",
    },
    { field: "gotra", headerName: "Gotra", minWidth: 150, flex: 0.5 },
  
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 200,
      flex: 0.8,
      renderCell: (params) => (
        <>
          {/* View Button */}
          <Button
            onClick={() =>
              checkOrderStatus(
                params.row.merchantOrderId,
                orders.find((o) => o._id === params.row.id)
              )
            }
            variant="outlined"
            color="primary"
            size="small"
            style={{ marginRight: "8px" }}
          >
            View
          </Button>

          {/* Delete Button */}
          <Button
            onClick={() => deleteOrderHandler(params.row.id)} // Using order ID for deletion
            variant="outlined"
            color="error"
            size="small"
          >
            <img src={DeleteIcon} className="products-func-img" alt="Delete" />
          </Button>
        </>
      ),
    },
  ];

  // ✅ Rows mapping from API response
  const rows = [];
  orders &&
    orders.forEach((order) => {
      // Extract merchantOrderId from the Payments array
      const merchantOrderId = order.Payments && order.Payments.length > 0 
        ? order.Payments[0].merchantOrderId 
        : "N/A";
      
      // Extract payment status from the Payments array
      const paymentStatus = order.Payments && order.Payments.length > 0 
        ? order.Payments[0].paymentStatus 
        : "N/A";

      rows.push({
        id: order._id, // ✅ OrderId
        merchantOrderId: merchantOrderId,
        status: paymentStatus,
        name: order?.name || "N/A",
        age: order?.age || "N/A",
        city: order?.city || "N/A",
        address: order?.address || "N/A",
        phone: order?.phoneNumber || "N/A",
        totalPrice: order?.totalPrice || 0,
        gotra: order?.gotra || "N/A",
      });
    });

  // ✅ useEffect for fetching + error/success handling
  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearErrors());
    }

    if (isDeleted) {
      toast.success("Order Removed Successfully!!");
      dispatch({ type: ADMIN_DELETE_ORDER_RESET });
      dispatch(getAllAdminOrders()); // refresh after delete
    } else {
      dispatch(getAllAdminOrders());
    }
  }, [dispatch, error, isDeleted]);

  return (
    <>
      <Sidebar />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="container">
            <h2>All Orders</h2>
          </div>
          <div className="view-product-container">
            <div className="row d-flex justify-content-center ">
              <div className="col-xl-10 col-md-12">
                <div className="order-data-card user-card-full ">
                  <div className="row">
                    {orders && orders.length > 0 ? (
                      <div style={{ height: "100%", width: "100%" }}>
                        <DataGrid
                          rows={rows}
                          columns={columns}
                          disableRowSelectionOnClick
                          autoHeight
                          pageSizeOptions={[10, 20, 50]}
                          cellClassName="grid-column"
                          sx={{
                            "& .MuiDataGrid-cell": { color: "white" },
                            "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: "#222",
                              color: "white",
                            },
                            backgroundColor: "#111",
                          }}
                        />
                      </div>
                    ) : (
                      <div className="empty-cart" style={{ color: "white" }}>
                        <h3 style={{ color: "white" }}>No Orders Data Found 🤷‍♂️</h3>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ✅ Modal for Order Status */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Order Status Details</DialogTitle>
        <DialogContent>
          {orderDetails ? (
            <div>
              <p>
                <strong>Merchant Order ID:</strong>{" "}
                {orderDetails.merchantOrderId}
              </p>
              <p>
                <strong>Status:</strong> {orderDetails.status}
              </p>
              <p>
                <strong>Total Price:</strong> ₹{orderDetails.totalPrice}
              </p>
              <p>
                <strong>Country:</strong> {orderDetails.country}
              </p>
              <p>
                <strong>Address:</strong> {orderDetails.address}
              </p>
            </div>
          ) : (
            <p>Loading details...</p>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AdminAllOrders;